import React from 'react';
import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';

import unityEPGService from '../../services/unityEPGService';
import {
  loadEPGDataFetchFailure,
  loadEPGDataFetchSuccess
} from './actions';

/**
 * Hook Effect to get EPG Api content data
 *
 * @export
 * @returns
 */
export function useContentEPGInfo(content, selectedDay, dispatch, tokenData) {
  const getContentEPGDataByDay = React.useCallback(
    async (selectedDay, content) => {
      const { epgId, id } = content;
      const from = startOfDay(selectedDay);
      const to = endOfDay(selectedDay);

      const { result } = await unityEPGService.fetchEPGDataById(tokenData, {
        contentID: id,
        epgID: epgId,
        from: from.toISOString(),
        to: to.toISOString()
      });

      if (!result || !Array.isArray(result)) {
        dispatch(loadEPGDataFetchFailure(result));
      }

      const { epg } = result[0];
      dispatch(loadEPGDataFetchSuccess(epg));
    }, [dispatch, tokenData]
  );

  React.useEffect(() => {
    if (selectedDay) {
      getContentEPGDataByDay(selectedDay, content);
    }
  }, [content, getContentEPGDataByDay, selectedDay]);
};

/**
 * Hooks effect to return component Dimensions
 *
 * @export
 * @returns
 */
export function useComponentDimensions(ref) {
  const getDimensions = React.useCallback(() => ({
    width: ref.current.offsetWidth,
    height: ref.current.offsetHeight
  }), [ref]
  );

  const [dimensions, setDimensions] = React.useState({ width: 0, height: 0 })

  React.useEffect(() => {
    const handleResize = () => {
      setDimensions(getDimensions());
    }

    if (ref.current) {
      setDimensions(getDimensions());
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [getDimensions, ref])

  return dimensions;
}